import "./AccountNotFoundStep.less";

import React, { Component } from "react";
import { translate } from "react-i18next"
import { Link } from "react-router-dom"

import StepContainer from "../StepContainer/StepContainer";
import dogSadImage from "../../../assets/images/dog_sad.svg";

class AccountNotFoundStep extends Component {
	render() {
		const t = this.props.t;

		return (
			<StepContainer>
				<div className="account-not-found">
					<img src={dogSadImage} />
					<p className="description">{t("description")}</p>
					<Link className="btn primarybtn" to="/registration">{t("button")}</Link>
				</div>
			</StepContainer>
		);
	}
}
export default translate("accountNotFound")(AccountNotFoundStep);


// WEBPACK FOOTER //
// ./src/components/Steps/AccountNotFoundStep/AccountNotFoundStep.js